module.exports = __webpack_public_path__ + "static/img/icon_sf_tab_sel.c8e9def.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_sf_tab_sel.png
// module id = v7Yg
// module chunks = 1